import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { PoFulfilmentPage } from '@/components/Operations/PoFulfilmentPage'
import {
  EMPTY_PO_FULFILMENT_SEARCH,
  type PoFulfilmentSearch,
  poFulfilmentSearchSchema,
  withoutPoFulfilmentDefaults,
} from '@/components/Operations/poFulfilmentSearch'

/** Wiring only. The schema lives beside the page in `poFulfilmentSearch.ts`. */
export const Route = createFileRoute('/_app/operations/po-fulfilment')({
  validateSearch: poFulfilmentSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_PO_FULFILMENT_SEARCH)] },
  component: PoFulfilmentRoute,
})

function PoFulfilmentRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<PoFulfilmentSearch>, options?: { push?: boolean }) =>
      void navigate({
        search: (current) => withoutPoFulfilmentDefaults({ ...current, ...next }),
        replace: !options?.push,
        resetScroll: false,
      }),
    [navigate],
  )
  return <PoFulfilmentPage search={search} onSearchChange={onSearchChange} />
}
